// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"c48f4b14","613":"26f34445","746":"d6ccd29b"}[chunkId] + ".chunk.js";
};